var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { fadeIn } from '../mixin/animation';
import { Color } from '../const';
var Overlay = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  animation: ", " 0.25s forwards ease-in-out;\n  background-color: ", ";\n  bottom: 0;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n"], ["\n  animation: ", " 0.25s forwards ease-in-out;\n  background-color: ", ";\n  bottom: 0;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n"])), fadeIn, Color.BLACK_ALPHA50);
export default Overlay;
var templateObject_1;
//# sourceMappingURL=overlay.js.map